const errorLog = {
  getlist: 'error/getlist',
  get: 'error/get',
  update: 'error/update',
}
export default errorLog
